<template>
  <div>
    <div class="ui-block">
      <!-- Post -->

      <article class="hentry post">
        <div class="post__author author vcard inline-items">
          <img src="/img/favicon.png" alt="author" />

          <div class="author-date">
            <a class="h6 post__author-name fn"
              >Swampum has sent a new message</a
            >
          </div>
        </div>
        <span>
          <p class="text-break">
            You have no messages with other users yet
            <br />
            <br />
            <router-link to="/s-app/feed" class="font-weight-bold modals"
              >Go to your feed</router-link
            >.
            <br />
            <br />
            and start a new conversation with other users
          </p>
        </span>
      </article>
    </div>
  </div>
</template>
<script>
export default {
  name: "SEmptyChatMessage",
  // methods: {

  // },
};
</script>
<style scoped>
.modals {
  cursor: pointer;
  color: purple;
}
</style>
